import { render, staticRenderFns } from "./BedbuilderUnavailableModal.vue?vue&type=template&id=cea615ee&scoped=true&"
import script from "./BedbuilderUnavailableModal.vue?vue&type=script&lang=js&"
export * from "./BedbuilderUnavailableModal.vue?vue&type=script&lang=js&"
import style0 from "./BedbuilderUnavailableModal.vue?vue&type=style&index=0&id=cea615ee&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea615ee",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppImg: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppImg.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
